import React from 'react'
import styled from 'styled-components'

const RedAsterisk = styled.span`
  color: #ef4444;
  margin-left: 2px;
`

interface RequiredAsteriskProps {
  children?: React.ReactNode
}

export const RequiredAsterisk: React.FC<RequiredAsteriskProps> = ({children}) => {
  return <RedAsterisk>{children || '*'}</RedAsterisk>
}

export default RequiredAsterisk
